import { Small } from "../../components/ui/typography";

export function Footer({ className }: { className?: string }) {
  const additonalClasses = className ? ` ${className}` : "";
  return (
    <footer className={"my-auto ml-auto print:hidden" + additonalClasses}>
      <Small>© Link Net</Small>
    </footer>
  );
}
